'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'base': 'USD',
  'date': '2017-08-07',
  'rates': {
    'AUD': 0.1333333333333,
    'CAD': 0.1333333333333,
    'CHF': 0.1,
    'CNY': 0.6666666666666,
    'EUR': 0.1,
    'GBP': 0.1,
    'HKD': 0.8,
    'ILS': 0.4,
    'JPY': 12,
    'SGD': 0.1333333333333,
    'USD': 0.1
  },
  'referral_rates': {
    'AUD': 20,
    'CAD': 20,
    'CHF': 15,
    'CNY': 100,
    'EUR': 15,
    'GBP': 15,
    'HKD': 120,
    'ILS': 60,
    'JPY': 1800,
    'SGD': 20,
    'USD': 15
  },
  'formats': {
    'AUD': 'A${amount}',
    'CAD': 'CA${amount}',
    'CHF': '{amount} CHF',
    'CNY': 'CN &yen; {amount}',
    'EUR': '{amount}&euro;',
    'GBP': '{amount} &pound;',
    'HKD': 'HK${amount}',
    'ILS': '&#8362;{amount}',
    'JPY': '&yen;{amount}',
    'SGD': '{amount} SGD',
    'USD': '${amount}'
  }
};